import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'

export const CardWrapper = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: column;
    border: 1px solid
        ${({ theme }) => theme.colors.semantic.collapsingBannerBorder};
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.semantic.drawerBackground};
`

export const CardHeader = styled('div')`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 16px;
`

export const RuleTitle = styled('div')`
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
`

export const RuleNameGroup = styled('div')`
    display: inline-flex;
    align-items: baseline;
    gap: 4px;
    min-width: 0;
    flex-wrap: wrap;
`

export const ToggleButton = styled('button')<{ theme?: TTheme }>`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    border: none;
    background: transparent;
    cursor: pointer;
    padding: 0;
    color: ${({ theme }) => theme.colors.primary[400]};
    white-space: nowrap;

    svg {
        transition: transform 0.25s ease;
    }
`

export const CardBody = styled('div')<{ isExpanded?: boolean }>`
    display: grid;
    grid-template-rows: ${({ isExpanded }) => (isExpanded ? '1fr' : '0fr')};
    opacity: ${({ isExpanded }) => (isExpanded ? 1 : 0)};
    transition:
        grid-template-rows 0.25s ease,
        opacity 0.25s ease;
`

export const CardBodyContent = styled('div')`
    overflow: hidden;
    min-height: 0;
    padding: 0 16px 16px;
`
